import { ttaCertifiedBadge, ttaQualifiedBadge, ttaVerifiedBadge } from "../assets/images";

export const getInstructorBadge = (status, instrId, setShowBadgeFunc, showBadge, wrapBadgeName, certifiedRoles = []) => {
  let className = wrapBadgeName ? "wrapBadge badgeTextWrap" : "overFlowBadge badgeTextWrap"

  if (status === "V") {
    return (
      <>
        <div className={showBadge === instrId ? className : "d-none"}>
          Verified: Independent contractor with experience in the field of learning and development
        </div>
        <img
          src={ttaVerifiedBadge}
          alt=""
          onMouseEnter={() => setShowBadgeFunc(instrId)}
          onMouseLeave={() => setShowBadgeFunc(null)}
        />
      </>
    );
  } else if (status === "Q") {
    return (
      <>
        <div className={showBadge === instrId ? className : "d-none"}>
          Qualified: Learning and development professional that has gone through our talent qualification process and has a demonstrated track record and expertise in their domain
        </div>
        <img
          src={ttaQualifiedBadge}
          alt=""
          onMouseEnter={() => setShowBadgeFunc(instrId)}
          onMouseLeave={() => setShowBadgeFunc(null)}
        />
      </>
    );
  } else if (status === "C") {
    return (
      <>
        {certifiedRoles.length > 0 && (
          <div className={showBadge === instrId ? className : "d-none"}>
            Certified roles: {certifiedRoles.join(", ")}
          </div>
        )}
        <img
          src={ttaCertifiedBadge}
          alt=""
          onMouseEnter={() => setShowBadgeFunc(instrId)}
          onMouseLeave={() => setShowBadgeFunc(null)}
        />
      </>
    );
  } else {
    return null;
  }
};